<template>
    <v-btn        
        text
        v-on:click="logOut"
      >
        <span class="mr-2">Logout</span>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    computed: {
      ...mapGetters({
          admin: 'auth/getAdmin',
      }) 
    },

    methods: {
        ...mapActions({
            signOut: 'auth/signOut'
        }),

        ...mapMutations({
            setOverlay: 'auth/setOverlay',
            setStep: 'auth/setStep',
            setExpand: 'auth/setExpand',            
        }),

        async logOut () {            
            this.setOverlay(true);
            this.setStep(1);
            await this.signOut();
            this.setExpand(true);
            if(this.admin){
                this.$router.replace('/admin');
                setTimeout(() => {this.setOverlay(false);}, 600);
                return;
            }
            this.$router.replace('/')
            this.setOverlay(false);
        }

        
    }
}
</script>